export var TermsLinkKind;
(function (TermsLinkKind) {
    TermsLinkKind["Url"] = "url";
    TermsLinkKind["DefaultText"] = "default_text";
    TermsLinkKind["CustomText"] = "custom_text";
    TermsLinkKind["NotLinked"] = "not_linked";
})(TermsLinkKind || (TermsLinkKind = {}));
//# sourceMappingURL=terms.types.js.map